@if (content) {
<modal-layout (close)="close()"
              [modalTitle]="content.title"
              class="block"
              sizeClass="!S: height-100vh">
    <ng-container modalBody>
        <!-- modal title -->
        <div *iCms="'subtitle' of content"
             class="p1"></div>
        <!-- stores list -->
        @for (store of stores; track $index) {
        <a [attr.href]="getStoreUrl(store)"
           (click)="goTo(store.siteId)"
           class="flex flex-middle m-t-10">
            <!-- store icon -->
            @if (store.icon) {
            <img [ratio]="1"
                 [width]="16"
                 [dfImage]="store.icon"
                 class="icon-medium">
            }
            <!-- store title -->
            <div *iCms="'title' of content"
                 class="s1 m-l-2 b-b"></div>
        </a>
        }
    </ng-container>
    <!-- close button -->
    @if (content.closeBtnCopy) {
    <button class="w-12"
            [buttonStyle]
            (click)="close()"
            modalFooter>
        <span *iCms="'closeBtnCopy' of content"></span>
    </button>
    }
</modal-layout>
}
